import React from 'react';
import { Text, View } from 'react-native';
import { EventsCalendar } from '../EventsCalendar';
import { HomeNextEvents } from '../HomeNextEvents';
import { HomeNotifications } from '../HomeNotifications';
import { AnimatedCard } from '../AnimatedCard';
import { CurrencySection } from '../CurrencySection';
import { FavouritesWatchlist } from '../FavouritesWatchlist';
import { ProductsNearExpiry } from '../ProductsNearExpiry';
import { SkeletonCard } from '../SkeletonLoader';
import { TopExposure } from '../TopExposure';
import { DashboardWidgetProps } from '../../config/dashboardWidgets/types';
import { styles } from '../../screens/HomeScreen/HomeScreen.styles';

export const CurrencyAllocationWidget: React.FC<DashboardWidgetProps> = ({
  includeWarrants,
  onCurrencyPress,
  hideLegendDetails,
  ownershipScope,
}) => (
  <CurrencySection
    includeWarrants={includeWarrants}
    onCurrencyPress={onCurrencyPress}
    hideLegendDetails={hideLegendDetails}
    ownershipScope={ownershipScope}
  />
);

export const ProductsNearExpiryWidget: React.FC<DashboardWidgetProps> = ({
  includeWarrants,
  onExpiryPress,
  ownershipScope,
}) => (
  <ProductsNearExpiry
    includeWarrants={includeWarrants}
    onExpiryPress={onExpiryPress}
    ownershipScope={ownershipScope}
  />
);

export const TopUnderlyingExposureWidget: React.FC<DashboardWidgetProps> = ({
  exposureItems,
  exposureLoading,
  onExposurePress,
  ownershipScope,
}) => (
  <AnimatedCard style={styles.card} animationType="slide" delay={200}>
    <View style={styles.sectionHeaderCustom}>
      <Text style={styles.sectionTitleCustom}>Top 10 Underlying Exposure</Text>
    </View>
    {exposureLoading ? (
      <SkeletonCard />
    ) : (
      <TopExposure
        items={[...exposureItems]}
        onExposurePress={onExposurePress}
        ownershipScope={ownershipScope}
      />
    )}
  </AnimatedCard>
);

export const FavouritesWatchlistWidget: React.FC<DashboardWidgetProps> = ({
  ownershipScope,
  onProductPress,
}) => (
  <AnimatedCard style={styles.card} animationType="slide" delay={250}>
    <FavouritesWatchlist ownershipScope={ownershipScope} onProductPress={onProductPress} />
  </AnimatedCard>
);

export const EventsCalendarWidget: React.FC<DashboardWidgetProps> = ({
  ownershipScope,
  includeWarrants,
  onCalendarDayPress,
}) => (
  <AnimatedCard style={[styles.card, styles.calendarCard]} animationType="slide" delay={280}>
    <EventsCalendar
      ownershipScope={ownershipScope}
      includeWarrants={includeWarrants}
      onDayPress={onCalendarDayPress}
    />
  </AnimatedCard>
);

export const NextEventsWidget: React.FC<DashboardWidgetProps> = ({
  ownershipScope,
  includeWarrants,
  onProductPress,
  onGoToEvents,
}) => (
  <AnimatedCard style={[styles.card, styles.notificationsCard]} animationType="slide" delay={280}>
    <HomeNextEvents
      ownershipScope={ownershipScope}
      includeWarrants={includeWarrants}
      onEventPress={onProductPress}
      onGoToEvents={onGoToEvents}
    />
  </AnimatedCard>
);

export const NotificationsWidget: React.FC<DashboardWidgetProps> = ({
  notifications,
  onNotificationPress,
  onGoToNotifications,
}) => (
  <AnimatedCard style={[styles.card, styles.notificationsCard]} animationType="slide" delay={280}>
    <HomeNotifications
      notifications={notifications}
      onNotificationPress={onNotificationPress}
      onGoToNotifications={onGoToNotifications}
    />
  </AnimatedCard>
);
